<template>
  <div class="footer">
    <div class="footer_wrapper">
      <p class="footer_title">{{$t('footerTitle1')}}</p>
      <p class="footer_content">
        {{$t('topTips1')}}
        <span>{{$t('topTips2')}}</span>
        {{$t('topTips3')}}</p>
      <p class="footer_title">{{$t('footerTitle2')}}</p>
      <p class="footer_content">{{$t('footerTips2')}}</p>
      <p class="footer_title">{{$t('footerTitle3')}}</p>
      <p class="footer_content">{{$t('footerTips3')}}</p>
      <p class="footer_content">{{$t('footerTips4')}}</p>
    </div>
    

  </div>
</template>

<script>
// @ is an alias to /src
import {mapState} from 'vuex'


export default {
  name: 'Footer',
  data(){
    return{
    }
  },
  computed: {
    ...mapState(['lang'])
  },
  methods: {
  }
}
</script>
<style lang="less" scoped>
.footer{
    width: 100%;
    // position: absolute;
    bottom: 0;
    left: 0;
    min-height: 100px;
    // background: #f5f5f5;
    // padding: 10px;
    margin-top: 80px;
    
    // margin-top: 50px;
    .footer_wrapper{
      width: 1440px;
      margin: 0 auto;
      padding: 40px 0;
      border-top: 1px solid #e1e1e1;
      .footer_title{
        font-size: 16px;
        color: #8b8b8c;
        font-weight: 600;
        margin-bottom: 10px;
      }
      .footer_content{
        font-size: 14px;
        color: #8b8b8c;
        font-weight: 400;
        margin-bottom: 10px;
        span{
          font-weight: 600;
        }
      }
    }
    p{
      text-align: left;
      color: #889199;
      
    }
}
</style>
